import { InputWithLabel } from '@adotel/components'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import { memo } from 'react'

import PageHeader from '../../components/PageHeader'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import useStyles from './styles/ChannelsHeader.styles'

interface ChannelsHeaderProps {
  inputValue: string | undefined
  setinputVal: (val: string) => void
}

const ChannelsHeader: React.FC<ChannelsHeaderProps> = ({
  inputValue,
  setinputVal
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAccessToCreateChannel = channelPagesRoleManagement
    .find((item) => item.route === '/channels/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <>
      <div className={classes.header}>
        <PageHeader title={getTranslate('Channels List')} />
        <Typography variant="h3" gutterBottom>
          {getTranslate('Channels List')}
        </Typography>
        {hasAccessToCreateChannel && (
          <Button
            startIcon={<AddIcon />}
            data-cy="AddChannelButton"
            variant="contained"
            color="primary"
            component={LocalizedLink}
            to="/channels/create">
            {getTranslate(isSmallScreen ? 'Add' : 'Add Channel')}
          </Button>
        )}
      </div>
      <div className={classes.root}>
        <InputWithLabel
          data-cy="channelSearchInput"
          placeholder={getTranslate('Search by name or code')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          className={classes.searchInput}
          value={inputValue}
          onChange={(event) => {
            setinputVal(
              convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
            )
          }}
        />
      </div>
    </>
  )
}

export default memo(ChannelsHeader)
